// extracted by mini-css-extract-plugin
export const container = "ExcursionAccessibilityLevel-module--container--31Zde";
export const withDescription = "ExcursionAccessibilityLevel-module--with-description--3KzcS";
export const title = "ExcursionAccessibilityLevel-module--title--3ZWo1";
export const body = "ExcursionAccessibilityLevel-module--body--1O1Y0";
export const sizeBig = "ExcursionAccessibilityLevel-module--size-big--1gUA3";
export const icon = "ExcursionAccessibilityLevel-module--icon--18O7V";
export const description = "ExcursionAccessibilityLevel-module--description--2lL4Q";